import _get from "lodash/get";

export default {
    data: () => ({
        loadingZip: false
    }),
    methods: {
        async searchZipCode(city, street, house) {
            const houseNumber = parseInt(house);

            this.loadingZip = true;

            try {
                const res = await this.$api.get(
                    `address/find-zip?city=${city}&street=${street}&house=${houseNumber}`
                );

                this.loadingZip = false;

                const response = res.data();

                if (!response.zip && houseNumber > 1) {
                    return this.searchZipCode(city, street, 1);
                }

                return response.zip;
            } catch (e) {
                if (houseNumber > 1) {
                    return this.searchZipCode(city, street, 1);
                }

                this.loadingZip = false;

                return null;
            }
        }
    }
};
